import * as z from "zod";

export const VehicleGroupSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1).max(255),
  description: z.string().nullable().optional(),
  thumbnail: z.string().nullable().optional(),
  images: z.array(z.string()).nullable().optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
  vehicle_type_ids: z.array(z.string().uuid()).optional(),
});

export const createVehicleGroupSchema = VehicleGroupSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateVehicleGroupSchema = VehicleGroupSchema.pick({
  name: true,
  description: true,
  thumbnail: true,
  images: true,
  vehicle_type_ids: true,
}).partial();

export const addVehiclesToGroupSchema = z.object({
  group_id: z.string().uuid(),
  vehicle_ids: z
    .array(z.string().uuid())
    .min(1, "At least one vehicle must be selected"),
});

export const removeVehiclesFromGroupSchema = z.object({
  group_id: z.string().uuid(),
  vehicle_ids: z
    .array(z.string().uuid())
    .min(1, "At least one vehicle must be selected"),
});
